/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */

export default function themeTypography(theme) {
    return {
        fontFamily: 'Inter',
        h6: {
            fontWeight: 600,
            color: theme.heading,
            fontSize: '1.125rem'
        },
        h5: {
            fontSize: '1.25rem',
            color: theme.heading,
            fontWeight: 600
        },
        h4: {
            fontSize: '1.65rem',
            color: theme.heading,
            fontWeight: 700
        },
        h3: {
            fontSize: '2.00rem',
            color: theme.heading,
            fontWeight: 700
        },
        h2: {
            fontSize: '2.50rem',
            color: theme.heading,
            fontWeight: 800
        },
        h1: {
            fontSize: '3.25rem',
            color: theme.heading,
            fontWeight: 800
        },
        subtitle1: {
            fontSize: '1.125rem',
            fontWeight: 600,
            color: theme.textDark
        },
        subtitle2: {
            fontSize: '1.00rem',
            fontWeight: 500,
            color: theme.darkTextSecondary
        },
        caption: {
            fontSize: '0.75rem',
            color: theme.darkTextSecondary,
            fontWeight: 500
        },
        body1: {
            fontSize: '1.125rem',
            fontWeight: 500,
            lineHeight: '1.334em'
        },
        body2: {
            letterSpacing: '0em',
            fontWeight: 500,
            lineHeight: '1.5em',
            color: theme.darkTextPrimary
        },
        button: {
            textTransform: 'capitalize'
        },
        customInput: {
            marginTop: 1,
            marginBottom: 1,
            '& > label': {
                top: 10,
                left: 0,
                color: theme.grey500,
                '&[data-shrink="false"]': {
                    top: 0
                }
            },
            '& > div > input': {
                padding: '20.5px 15px 5.5px !important'
            },
            '& legend': {
                display: 'none'
            },
            '& fieldset': {
                top: 0
            }
        },
        mainContent: {
            backgroundColor: theme.background,
            width: '100%',
            minHeight: 'calc(100vh - 88px)',
            flexGrow: 1,
            padding: '20px',
            marginTop: '88px',
            marginRight: '20px',
            borderRadius: `${theme?.customization?.borderRadius}px`
        },
        menuCaption: {
            fontSize: '1.125rem',
            fontWeight: 600,
            color: theme.heading,
            padding: '6px',
            textTransform: 'capitalize',
            marginTop: '10px'
        },
        subMenuCaption: {
            fontSize: '0.9375rem',
            fontWeight: 600,
            color: theme.darkTextSecondary,
            textTransform: 'capitalize'
        },
        commonAvatar: {
            cursor: 'pointer',
            borderRadius: '8px'
        },
        smallAvatar: {
            width: '22px',
            height: '22px',
            fontSize: '1.25rem'
        },
        mediumAvatar: {
            width: '34px',
            height: '34px',
            fontSize: '1.45rem'
        },
        largeAvatar: {
            width: '44px',
            height: '44px',
            fontSize: '1.75rem'
        }
    };
}
